module.exports = __webpack_public_path__ + "img/liku.7c586d55.png";